<template>
  <div class="approved_wrapper" v-if="item">
    <div class="page page1">
      <h1>裕富數位資融股份有限公司</h1>
      <h3>核准通知書</h3>
      <div class="topBox">
        <div class="leftBox">
          <div class="row">
            <div class="tit">審件編號：</div>
            <div class="con">{{ displayId  }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">專案說明：</div>
            <div class="con">{{ item.promoName }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">借新還舊：</div>
            <div class="con">{{ (item.promoNo === 'DN81' || item.promoNo === 'DN82') ? 'Y': 'N'}}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">客戶ID：</div>
            <div class="con">{{ item.customer[0].idno }} {{ item.customer[0].name }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row row1">
            <div class="tit">保人ID：</div>
            <div class="con">{{ (info && info.jointGuarantor.name !=='') ? `${info.jointGuarantor.memberId} ${info.jointGuarantor.name}` : '' }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">商品名稱：</div>
            <div class="con">{{ item.carBrand }} {{ item.carName }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">牌照號碼：</div>
            <div class="con">{{ item.carNo }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">商品價格：</div>
            <div class="con">{{ (parseInt(item.payment[0].instNo) * parseInt(item.payment[0].instAmt )) }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">頭期款：</div>
            <div class="con">0</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">貸款本金：</div>
            <div class="con">{{ item.instCap }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">期數：</div>
            <div class="con">{{ item.payment[0].instNo }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">期付款：</div>
            <div class="con">{{ item.payment[0].instAmt }}</div>
            <div class="clear"></div>
          </div><!--row-->
        </div><!--leftBox-->
        <div class="rightBox">
          <div class="row">
            <div class="tit">收件日：</div>
            <div class="con">{{ info ? `${parseInt(info.applyDate.year)+1911}${info.applyDate.month}${info.applyDate.day}` : ''}}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">回覆日：</div>
            <div class="con">{{ item.approveDate }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row row2">
            <div class="tit">通路商/據點：</div>
            <div class="con con1">嘉好企業有限公司</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">通路商補助款：</div>
            <div class="con"></div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">實播金額：</div>
            <div class="con"></div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">佣金-個：</div>
            <div class="con">{{ item.brokeragePersonal }}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">據點聯絡人：</div>
            <div class="con">{{ info ? info.parentAgent.displayName : ''}}</div>
            <div class="clear"></div>
          </div><!--row-->
          <div class="row">
            <div class="tit">業務人員：</div>
            <div class="con con2">嘉好企業有限公司</div>
            <div class="clear"></div>
          </div><!--row-->
        </div><!--rightBox-->
        <div class="clear"></div>
      </div><!--topBox-->
      <div class="btBox">
        <div class="row">
          <div class="tit">請款注意事項：</div>
          <div class="con con1"></div>
          <div class="clear"></div>
        </div><!--row-->
        <div class="row row1">
          <div class="tit">備註說明：</div>
          <div class="con con2">{{ info ? info.comment : '' }}</div>
          <div class="clear"></div>
        </div><!--row-->
        <div class="row row2">
          <div class="tit">撥款對象：</div>
          <div class="con">{{ bankName }} {{ bankSubName }} {{ bankAccount }} {{ item.customer[0].name }}</div>
          <div class="clear"></div>
        </div><!--row-->
      </div><!--btBox-->
      <div class="bt-right">{{ now }}</div>
    </div><!--page2-->
  </div><!--wrapper-->
</template>

<script>
import { mapActions } from "vuex";
import common from '@/mixins/common';
import { getNow } from '@/pages/utils/tool';

export default {
  name: 'ApprovedView',
  mixins: [common],
  data(){
    return {
      item: null,
      displayId: '',
      info: null,
      bankData: require('../../assets/bank_data.json'),
      bankName: '',
      bankSubName: '',
      bankAccount: '',
      now: getNow(),
    }
  },
  created() {
    this.loadData();
  },
  methods:{
    ...mapActions(['queryCaseStatus', 'fetchFinanceCreditInfoBy']),
    async loadData(){
      this.displayId = this.$route.query.displayId;
      const salesId = this.$route.query.salesId ? this.$route.query.salesId : '';
      const memberId = this.$route.query.memberId;
      console.log(`${this.displayId} / ${salesId} / ${memberId}`);
      if (this.displayId && memberId) {
        const param = {
          salesId: salesId,
          displayId: this.displayId,
          memberId: memberId
        }

        const res = await this.queryCaseStatus(param);
        this.loading = false;
        const result = res.data
        console.log(`裕富線上案件狀態查詢 === ${JSON.stringify(result.data)}`)
        if(result.data.code === 'S001') {
            this.item = result.data;
            const findBank = this.bankData[this.item.payee.bankCode];
            this.bankAccount = this.item.payee.accountNo;
            if (findBank){
              this.bankName = findBank.branch;
              const findKey = `${this.item.payee.bankCode}${this.item.payee.bankDetailCode}`;
              const findSubBank = findBank.child.find(b=>b.code === findKey);
              if (findSubBank){
                this.bankSubName = findSubBank.branch;
              }
            }
            console.log(`bankName === ${ this.bankName } ${this.bankSubName} ${this.bankAccount}`);

            await this.loadItemInfo();
        }
      }
    },
    async loadItemInfo(){
      const results = await this.fetchFinanceCreditInfoBy({ key:'displayId', value: this.displayId });
      if (results.length > 0){
        this.info = results[0];
        console.log(`裕富案件資訊 === ${JSON.stringify(this.info)}`)
      }
    }
  },
};
</script>

<style scoped src="../../assets/css/approved_view.css">

</style>



// WEBPACK FOOTER //
// src/pages/web/ApprovedView.vue